export default __webpack_public_path__ + "static/media/blue_barbet.f525107f.jpg";